import {
	selectIsActive,
	selectIsAuthenticated,
	selectIsInitialized,
	selectProfile,
	selectRole,
	selectSession,
	selectStaffSchoolIds,
	selectStatus,
} from "@/src/auth/store/auth.selectors";
import { useAppSelector } from "@/src/common/redux/store";

export function useAuth() {
	return {
		session: useAppSelector(selectSession),
		profile: useAppSelector(selectProfile),
		role: useAppSelector(selectRole),
		status: useAppSelector(selectStatus),
		schoolIds: useAppSelector(selectStaffSchoolIds),
		isAuthenticated: useAppSelector(selectIsAuthenticated),
		isActive: useAppSelector(selectIsActive),
		isInitialized: useAppSelector(selectIsInitialized),
	};
}
